import { render } from "./yjyc.vue?vue&type=template&id=496e9c58&scoped=true&ts=true"
import script from "./yjyc.vue?vue&type=script&lang=ts"
export * from "./yjyc.vue?vue&type=script&lang=ts"

import "./yjyc.vue?vue&type=style&index=0&id=496e9c58&lang=less&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-496e9c58"]])

export default __exports__